import {
    forwardRef,
    useImperativeHandle,
} from 'react'

const DisclosureForFcra = forwardRef(({ company, data, refToPrint }, ref) => {

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {},
            }
        },
    }))


    return (
        <div ref={refToPrint} className="flex items-center justify-center px-4 py-10">
            <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl p-8 space-y-6">
                <div className="space-y-2">
                    <h1 className="text-2xl font-bold text-gray-800">
                        FCRA Disclosure Regarding Identity Validation
                    </h1>
                    <p className="text-base text-gray-700">
                        <span className="font-semibold">{company?.name} (the "Company")</span> may obtain an identity
                        verification report (which is a form of "consumer report") about you from{' '}
                        <span className="font-semibold">VerifiedID LLC and its authorized agents</span> (acting as a
                        third-party consumer reporting agency) for employment purposes, specifically as a prerequisite
                        for interview scheduling and shortlisting.
                    </p>
                    <p className="text-base text-gray-700">
                        As part of this "PreCheck" process, you will be the subject of a report which includes
                        information about your identity, personal characteristics, and professional credentials.
                    </p>
                </div>

                <div className="bg-gray-100 p-4 rounded-lg text-sm text-gray-700 space-y-2 border border-gray-200">
                    <p className="font-semibold text-gray-800">This report may include:</p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>
                            <strong>Identity Authentication</strong> — Validation of government-issued identification.
                        </li>
                        <li>
                            <strong>Biometric Comparison</strong> — A facial 'Match Selfie' compared against your provided identification.
                        </li>
                        <li>
                            <strong>Identifier Verification</strong> — Confirmation of identifiers such as email, mobile number, and the last 4 digits of your SSN.
                        </li>
                    </ul>
                </div>

                <div className="bg-gray-100 p-4 rounded-lg text-sm text-gray-700 space-y-1 border border-gray-200">
                    <p className="font-semibold text-gray-800">VerifiedID LLC is located at:</p>
                    <p>11180 State Bridge Road, suite 303, Alpharetta, GA, 30022, USA</p>
                </div>

                <p className="text-sm text-gray-700 italic font-semibold">PLEASE READ CAREFULLY</p>
            </div>
        </div>
    )
})

export default DisclosureForFcra
